import React, { FunctionComponent } from 'react';
import { Chip, ChipProps, Stack, Typography } from '@mui/material';
import moment from 'moment';

import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../components/V2/Table/type1/TableStyles';
import {
  IZoomMeetingRequest,
  ZOOM_MEETING_REQUEST_STATUSES,
  ZOOM_MEETING_REQUEST_TYPES,
} from '../../../../../../store/V2/ZoomRequestsSlice';

interface RescheduledOrCancelledTableRowProps {
  requestData: IZoomMeetingRequest;
  selected: boolean;
  onSelectRow: () => void;
}

// const actionButtonStyles: SxProps = {
//   borderRadius: '8px',
//   padding: '10px 12px 10px 12px',
//   fontWeight: 600,
//   fontSize: '14px',
//   maxHeight: '36px',
//   backgroundColor: '#006C9C',
//   color: '#F8FAFC',
// };

const RescheduledOrCancelledTableRow: FunctionComponent<RescheduledOrCancelledTableRowProps> = ({
  requestData,
}) => {
  const reason = requestData.reason || '-';
  const requestedAt = moment(requestData.createdAt);
  const scheduledAt = requestData.start ? moment(requestData.start) : undefined;
  const newScheduledAt = requestData.newStart
    ? moment(requestData.newStart)
    : null;

  const rescheduleTypeBadgeProps: ChipProps = {
    size: 'small',
    label: requestData.type.toLocaleLowerCase(),
    color: 'warning',
    sx: {
      textTransform: 'capitalize',
      width: '100%',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 600,
    },
  };

  const rescheduleStatusBadgeProps: ChipProps = {
    size: 'small',
    label: requestData.status.toLocaleLowerCase(),
    color: 'warning',
    sx: {
      textTransform: 'capitalize',
      width: '100%',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 600,
    },
  };

  let studentName = '-';

  if (requestData.student) {
    studentName = requestData.student.firstname;

    if (requestData.student.lastname) {
      studentName += ` ${requestData.student.lastname}`;
    }
  }

  switch (requestData.type) {
    case ZOOM_MEETING_REQUEST_TYPES.CANCEL:
      rescheduleTypeBadgeProps.color = 'error';
      break;

    case ZOOM_MEETING_REQUEST_TYPES.DELETE:
      rescheduleTypeBadgeProps.color = 'error';
      break;

    default:
      break;
  }

  switch (requestData.status) {
    case ZOOM_MEETING_REQUEST_STATUSES.APPROVED:
      rescheduleStatusBadgeProps.color = 'success';
      break;

    case ZOOM_MEETING_REQUEST_STATUSES.REJECTED:
      rescheduleStatusBadgeProps.color = 'error';
      break;

    default:
      break;
  }

  return (
    <StyledTableRow hover key={requestData._id}>
      {/* <StyledTableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </StyledTableCell> */}
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {studentName}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {requestedAt.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {requestedAt.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {scheduledAt ? scheduledAt.format('ddd MMM DD YYYY') : '-'}
        </Typography>
        {scheduledAt ? (
          <Typography fontSize="12px" color="#94A3B8">
            {scheduledAt.format('hh:mm A')}
          </Typography>
        ) : null}
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {newScheduledAt ? newScheduledAt.format('ddd MMM DD YYYY') : '-'}
        </Typography>
        {newScheduledAt ? (
          <Typography fontSize="12px" color="#94A3B8">
            {newScheduledAt.format('hh:mm A')}
          </Typography>
        ) : null}
      </StyledTableCell>
      <StyledTableCell>
        <Chip {...rescheduleTypeBadgeProps} />
      </StyledTableCell>
      <StyledTableCell>
        <Chip {...rescheduleStatusBadgeProps} />
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {reason}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RescheduledOrCancelledTableRow;
